/**
 * Recently viewed rail — reads Horizon localStorage `viewedProducts`
 * and hydrates up to 4 cards via the search Section Rendering API.
 */
(function () {
  var STORAGE_KEY = 'viewedProducts';
  var MAX = 4;

  function readIds() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(raw) ? raw.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function wantedIds(current) {
    var cur = String(current || '');
    var out = [];
    readIds().forEach(function (id) {
      if (!id || id === cur) return;
      if (out.indexOf(id) !== -1) return;
      out.push(id);
    });
    return out.slice(0, MAX);
  }

  async function hydrate(root) {
    if (!root || root.dataset.veroniRecentReady) return;
    var ids = wantedIds(root.getAttribute('data-current-product'));
    if (!ids.length) {
      root.hidden = true;
      return;
    }
    var sectionId = root.getAttribute('data-section-id') || 'veroni-recently-viewed';
    var url = new URL('/search', window.location.origin);
    url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', sectionId);
    try {
      var res = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(String(res.status));
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('[data-veroni-recent-grid]');
      var mount = root.querySelector('[data-veroni-recent-mount]');
      if (!grid || !mount || !grid.children.length) {
        root.hidden = true;
        return;
      }
      mount.replaceChildren(grid);
      root.hidden = false;
      root.dataset.veroniRecentReady = '1';
    } catch (e) {
      root.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll('[data-veroni-recent]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
